//import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
/*import { Platform } from 'ionic-angular/platform/platform';
import { ToastController } from 'ionic-angular/components/toast/toast-controller';*/

@Injectable()
export class PushServiceProvider {

    constructor(
       /* private platform: Platform,
        private toastCtrl: ToastController*/
    ) { }
    /*
        pushInit(): Promise<any> {
            return this.fcm.getToken();
        }
    
        pushToken(): Observable<any> {
            return this.fcm.onTokenRefresh();
        }
    
        pushNotification(): Observable<any> {
            return this.fcm.onNotification();
        }
    
        pushSubscribe(channel: string) {
            this.fcm.subscribeToTopic(channel);
        }
    
        pushUnsubscribe(channel: string) {
            this.fcm.unsubscribeFromTopic(channel);
        }
        */
}


// WEBPACK FOOTER //
// ./src/providers/push-service/push-service.ts